<div class="modal-shell">
  <div class="modal-header-row">
    <div>
      <h2 class="modal-title">Verify Email</h2>
      <p class="modal-subtitle">
        Enter the 6 digit OTP sent to your registered email.
      </p>
    </div>
    <button type="button" class="close-btn" (click)="dissmissModal()" aria-label="Close">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <form [formGroup]="signupFormConfirm" (ngSubmit)="submit()" class="modal-form">
    <label class="field-label">Confirmation Code</label>
    <p-inputOtp
      formControlName="otp"
      [length]="6"
      [integerOnly]="true"
      styleClass="otp-input">
    </p-inputOtp>

    <p class="countdown-text" *ngIf="timeLeft > 0">
      OTP expires in {{ timeLeft }}s
    </p>

    <p
      class="error-message"
      *ngIf="signupFormConfirm.get('otp')?.invalid && signupFormConfirm.get('otp')?.touched">
      Please enter a valid 6 digit OTP.
    </p>

    <div class="action-row">
      <button type="button" class="btn-secondary" (click)="dissmissModal()">
        Cancel
      </button>
      <button type="submit" class="btn-primary" [disabled]="signupFormConfirm.invalid">
        Verify OTP
      </button>
    </div>
  </form>
</div>
